export default "__VITE_ASSET__CTtUV0Dl__"